import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";
import CounterpartyBankAccountType from "./counterpartyBankAccountType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EshopTransferOrderDetailResponse {
  @observable
  @Type(() => CounterpartyBankAccountResponse)
  counterpartyBankAccount?: CounterpartyBankAccountResponse;

  @observable
  counterpartyBankAccountType?: CounterpartyBankAccountType;
}
